'use client'

import { ComponentProps } from 'react'

import { I18nProvider as DesignSystemI18nProvider } from '@themenu/design-system'
import { IntlProvider } from 'react-intl'

import messages, { useLocale } from 'i18n'
import { logger } from 'lib/analytics/logger'

function MergedI18nProvider({
  children
}: Omit<ComponentProps<typeof DesignSystemI18nProvider>, 'locale'>) {
  const locale = useLocale()

  return (
    <DesignSystemI18nProvider locale={locale}>
      {children}
    </DesignSystemI18nProvider>
  )
}

type I18nProviderProps = {
  locale: keyof typeof messages
} & Pick<ComponentProps<typeof IntlProvider>, 'children'>

export function I18nProvider({ children, locale }: I18nProviderProps) {
  return (
    <IntlProvider
      locale={locale}
      messages={messages[locale]}
      onError={(error) => {
        if (error.code === 'MISSING_TRANSLATION') {
          const { descriptor } = error
          logger.error('Missing translation key', { descriptor }, error)
        }
      }}
    >
      <MergedI18nProvider>{children}</MergedI18nProvider>
    </IntlProvider>
  )
}
